export const STATIC_RESOURCE = 'https://static.loopring.io/assets'
export const EXPIRE_TIMESTAMP = 1720108800000